import { Component } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { isCountryCodeBelgian } from '../countries/country-service';

@Component({
  selector: 'app-left-website',
  templateUrl: './left-website.component.html',
  styleUrls: ['./left-website.component.scss'],
})
export class LeftWebsiteComponent {
  constructor(private readonly authService: AuthService) {}

  get frontpageTextKey(): string {
    return isCountryCodeBelgian(this.authService.getCountry()) ? 'frontpage.text_be' : 'frontpage.text';
  }
}
